import { FormEvent, useState } from 'react';
import { GiftRedemptionService } from '../services/giftRedemptionService';
import { ApiError } from '../errors/ApiError';

// "Enter your claim code" front door (PT-2616) - an alternative to the emailed signed link,
// for recipients reached by flyer/word of mouth instead of email. Resolves the code to the
// recipient's normal claim URL and redirects there; GiftRedemptionPage.tsx takes over from
// that point on, unchanged.
export function GiftCodeEntryPage() {
  const [code, setCode] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      const { claimUrl } = await GiftRedemptionService.resolveByCode(code);
      window.location.href = claimUrl;
    } catch (thrownError) {
      setError(thrownError instanceof ApiError ? thrownError.message : 'This code is not valid or has expired.');
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-sm w-full">
        <h1 className="text-xl font-semibold text-gray-800 mb-2 text-center">Enter Your Claim Code</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            value={code}
            onChange={(event) => setCode(event.target.value.toUpperCase())}
            placeholder="C O D E"
            autoFocus
            className="w-full text-center text-lg tracking-widest uppercase border border-gray-300 rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-gray-800"
          />
          {error && <p className="text-red-600 text-sm text-center">{error}</p>}
          <button
            type="submit"
            disabled={submitting || code.length !== 6}
            className="w-full bg-gray-900 text-white rounded-md py-3 font-medium disabled:opacity-50"
          >
            {submitting ? 'Checking…' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  );
}
